import { Injectable } from '@angular/core';

const STORAGE_KEY = 'team-action-mock.show-new';

// Maquette d'estimation « action d'équipe » : réglages de la démo, retenus pour la personne qui présente.
@Injectable({ providedIn: 'root' })
export class TeamActionMockSettingsService {
  /** Affiche la pastille « Nouveau » sur ce que chaque option change. */
  showNew = this.readShowNew();

  setShowNew(value: boolean): void {
    this.showNew = value;
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch {
      // Stockage indisponible (navigation privée) : le choix vaut pour la session.
    }
  }

  private readShowNew(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY) !== 'false';
    } catch {
      return true;
    }
  }
}
